import { absolutePath } from "../absolutePath";

export const spaceGroups = {
  show: (id: number) => absolutePath(`access_registry/space_groups/${id}`),
};
